module.exports = __webpack_public_path__ + "fonts/SF-Pro-Display-UltralightItalic.fa570fc4.otf";